import { useState, useEffect, useRef } from "react";
import React from "react";
import { NavLink, useNavigate, Link, useLocation } from "react-router-dom";
import {
  Box,
  Flex,
  Image,
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
  Stack,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Collapse,
  Text,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon, HamburgerIcon, DownloadIcon } from "@chakra-ui/icons";

import logo from "../../assets/logo.png";
import Winnsta from "../../assets/winnsta.png";

const Navbar = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  const location = useLocation();
  const pathname = location.pathname;

  const [showGames, setShowGames] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const isGamesActive = pathname.startsWith("/games");

  // 🔥 Scroll blur effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const downloadFile = () => {
    const fileUrl = "https://play.google.com/store/apps/details?id=com.PurpleFoxLeisurePrivateLimited.winnsta";
    const link = document.createElement("a");
    // link.href = fileUrl;
    link.download = "Winnsta App";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const linkStyle = {
    color: "#9CA3AF",
    fontSize: "16px",
    fontFamily: "Montserrat, sans-serif",
    textDecoration: "none",
  };

  const activeLinkStyle = {
    ...linkStyle,
    color: "#fff",
  };

  return (
    <Box
      position="sticky"
      top="0"
      zIndex="1000"
      px={{ base: 2, md: 12 }}
      py={4}
      transition="all 0.3s ease"
      bg={scrolled ? "rgba(3, 0, 20, 0.6)" : "#030014"}
      backdropFilter={scrolled ? "blur(12px)" : "none"}
      boxShadow={scrolled ? "0 8px 30px rgba(0,0,0,0.4)" : "none"}
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Link to="/">
          <Image
            src={Winnsta}
            alt="Logo"
            w={{ base: "120px", sm: "140px", md: "160px", lg: "180px" }}
            h="auto"
            objectFit="contain"
          />

        </Link>

        {/* Desktop Nav */}
        <Flex display={{ base: "none", md: "flex" }} alignItems="center" gap={12}>
          <NavLink to="/tournaments" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>
            Tournaments
          </NavLink>

          <NavLink to="/about-us" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>
            About Us
          </NavLink>

          <NavLink to="/#games" style={linkStyle}>
            Games
          </NavLink>

          <NavLink to="/contact-us" style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}>
            Contact Us
          </NavLink>

          <Button
            ml="40px"
            px={6}
            py={2.5}
            borderRadius="full"
            fontWeight="bold"
            color="white"
            onClick={downloadFile}
            transition="all 0.25s ease"
            position="relative"
            border="2px solid transparent"
            bgGradient="linear(135deg, #7C3AED 0%, #A855F7 50%, #D946EF 100%)"
            sx={{
              backgroundImage:
                "linear-gradient(135deg, #7C3AED, #A855F7, #D946EF), linear-gradient(135deg, #7C3AED, #A855F7, #D946EF)",
              backgroundOrigin: "border-box",
              backgroundClip: "padding-box, border-box",
            }}
            _hover={{
              // bg: "transparent",
              transform: "scale(1.05)",
            }}
            _focus={{ boxShadow: "none" }}
            leftIcon={<DownloadIcon />}
          >
            Download
          </Button>
        </Flex>

        {/* Mobile Hamburger */}
        <IconButton
          ref={btnRef}
          icon={<HamburgerIcon boxSize={6} />}
          variant="ghost"
          color="white"
          aria-label="Open Menu"
          display={{ base: "flex", md: "none" }}
          onClick={onOpen}
          _hover={{ bg: "transparent" }}
          _active={{ bg: "transparent" }}
          _focus={{ bg: "transparent", boxShadow: "none" }}
          sx={{ WebkitTapHighlightColor: "transparent" }}
        />
      </Flex>

      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent bg="#0d0d0d" color="white">
          <DrawerCloseButton />
          <DrawerBody>
            <Stack spacing={6} mt={10}>
              <NavLink to="/tournaments" onClick={onClose} style={linkStyle}>
                Tournaments
              </NavLink>

              <NavLink to="/about-us" onClick={onClose} style={linkStyle}>
                About Us
              </NavLink>

              <NavLink to="/#games" onClick={onClose} style={linkStyle}>
                Games
              </NavLink>

              <NavLink to="/contact-us" onClick={onClose} style={linkStyle}>
                Contact Us
              </NavLink>

              <Button
                onClick={downloadFile}
                bgGradient="linear(135deg, #7C3AED, #A855F7, #D946EF)"
                color="white"
                fontWeight="bold"
                borderRadius="full"
                leftIcon={<DownloadIcon />}
              >
                Download
              </Button>
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default Navbar;
